import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, Users, Sparkles, Wallet, Ticket, Bell, Heart, Settings, TrendingUp } from "lucide-react";

const NAV = [
  { to: "/", label: "Início", icon: LayoutDashboard, exact: true, id: "nav-dashboard" },
  { to: "/clientes", label: "Clientes", icon: Users, id: "nav-clients" },
  { to: "/tatuagens", label: "Tatuagens", icon: Sparkles, id: "nav-tattoos" },
  { to: "/financeiro", label: "Financeiro", icon: Wallet, id: "nav-financial" },
  { to: "/insights", label: "Insights", icon: TrendingUp, id: "nav-insights" },
  { to: "/lembretes", label: "Lembretes", icon: Bell, id: "nav-reminders" },
  { to: "/pos-atendimento", label: "Pós-Atendimento", icon: Heart, id: "nav-postcare" },
  { to: "/sorteio", label: "Sorteio", icon: Ticket, id: "nav-draw" },
  { to: "/configuracoes", label: "Configurações", icon: Settings, id: "nav-settings" },
];

export default function Layout() {
  return (
    <div className="min-h-screen bg-[#FDFCF7] bg-grain">
      <div className="flex flex-col lg:flex-row">
        <aside className="lg:w-72 lg:min-h-screen border-b lg:border-b-0 lg:border-r border-[#E8E4D9] bg-[#FDFCF7]/80 backdrop-blur-sm lg:fixed lg:top-0 lg:left-0 lg:overflow-y-auto">
          <div className="px-8 pt-10 pb-6">
            <div className="flex items-baseline gap-1">
              <span className="brand-mark text-4xl text-[#2E332C]">Julliet</span>
              <span className="brand-mark text-4xl text-[#7B8B6F]">.Ink</span>
            </div>
            <p className="text-xs uppercase tracking-[0.25em] text-[#5C6658] mt-3">
              Tattoo Studio · Gestão
            </p>
          </div>

          <nav className="px-4 pb-10 space-y-0.5">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.exact}
                data-testid={item.id}
                className={({ isActive }) =>
                  `sidebar-link flex items-center gap-3 px-5 py-2.5 rounded-xl transition-all ${
                    isActive ? "active bg-[#F1EEE3] text-[#2E332C]" : "text-[#5C6658] hover:bg-[#F5F2E8]"
                  }`
                }
              >
                <item.icon className="w-[18px] h-[18px]" strokeWidth={1.5} />
                <span className="text-sm font-medium">{item.label}</span>
              </NavLink>
            ))}
          </nav>
        </aside>

        <main className="flex-1 lg:ml-72 px-6 sm:px-10 lg:px-14 py-10 lg:py-14">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
